/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  IconButton,
  Button,
  Tooltip,
  TextField,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import DoneIcon from "@material-ui/icons/Done";
import PropTypes from "prop-types";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";

const useStyles = makeStyles(() => ({
  deliveryStatusTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 10,
  },
  dialogTitle: {
    fontSize: 18,
    color: "#1558a2",
    fontWeight: 700,
  },
  button: {
    fontSize: 12,
    textTransform: "capitalize",
    marginRight: 5,
    marginLeft: 5,
  },
  subStatusTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 10,
    marginTop: 10,
  },
  actions: {
    marginTop: 20,
    float: "right",
  },
  orderWarningMsg: {
    marginBottom: 10,
    marginRight: 10,
    marginLeft: 10,
    color: "grey",
    fontSize: 12,
    textAlign: "center",
    backgroundColor: "antiquewhite",
    padding: 6,
  },
}));

const C13ChangeDeliveryStatusDialog = (props) => {
  const classes = useStyles();
  const { handleClose, open, onHandleChange, state, onSaveClick } = props;

  return (
    <Fragment>
      <ControlledDialog
        open={open}
        disableBackdropClick
        disableEscapeKeyDown={state.changeStatusLoading}
        handleClose={() => handleClose()}
        title={
          <Fragment>
            <Tooltip title="Back">
              <IconButton
                disabled={state.changeStatusLoading}
                onClick={() => handleClose()}
              >
                <ArrowBackIcon fontSize="small" color="primary" />
              </IconButton>
            </Tooltip>
            <span
              className={classes.dialogTitle}
            >{`${state.selectedOrder.orderId} - ${state.selectedOrder.deliveryPartnerLabel} - (${state.selectedOrder.statusLabel})`}</span>
          </Fragment>
        }
        content={
          <Fragment>
            {state.selectedOrder.orderStatusId == 21 && (
              <div className={classes.orderWarningMsg}>
                <b>NOTE :</b> Order is in returned state So, we can not change
                the status from this dialog.
              </div>
            )}
            <div className={classes.deliveryStatusTitle}>Delivery Status *</div>
            <div>
              <Button
                name="changeStatusId"
                id="changeStatusId"
                disabled={
                  state.selectedOrder.orderStatusId != 4 ||
                  state.changeStatusLoading
                }
                onClick={(e) => {
                  e.preventDefault();
                  const value = state.changeStatusId == 1 ? "" : 1;
                  onHandleChange({
                    target: {
                      name: "changeStatusId",
                      value: value,
                    },
                  });
                }}
                value={state.changeStatusId}
                variant={state.changeStatusId == 1 ? "contained" : "outlined"}
                color="primary"
                className={classes.button}
                startIcon={state.changeStatusId == 1 ? <DoneIcon /> : null}
              >
                Delivered
              </Button>
              <Button
                name="changeStatusId"
                id="changeStatusId"
                disabled={
                  state.selectedOrder.orderStatusId != 4 ||
                  state.changeStatusLoading
                }
                onClick={(e) => {
                  e.preventDefault();
                  const value = state.changeStatusId == 2 ? "" : 2;
                  onHandleChange({
                    target: {
                      name: "changeStatusId",
                      value: value,
                    },
                  });
                }}
                value={state.changeStatusId}
                variant={state.changeStatusId == 2 ? "contained" : "outlined"}
                color="primary"
                className={classes.button}
                startIcon={state.changeStatusId == 2 ? <DoneIcon /> : null}
              >
                Un-Delivered
              </Button>
            </div>
            <div className={classes.subStatusTitle}>
              Operational Status (Optional)
            </div>
            <div>
              <Button
                name="changeOtherStatusId"
                id="changeOtherStatusId"
                disabled={
                  !state.changeStatusId ||
                  state.changeStatusId == 2 ||
                  state.changeStatusLoading ||
                  state.selectedOrder.orderStatusId == 21
                }
                onClick={(e) => {
                  e.preventDefault();
                  const value = state.changeOtherStatusId == 1 ? "" : 1;
                  onHandleChange({
                    target: {
                      name: "changeOtherStatusId",
                      value: value,
                    },
                  });
                }}
                value={state.changeOtherStatusId}
                variant={
                  state.changeOtherStatusId == 1 ? "contained" : "outlined"
                }
                color="primary"
                className={classes.button}
                startIcon={state.changeOtherStatusId == 1 ? <DoneIcon /> : null}
              >
                Payment Received
              </Button>
              <Button
                name="changeOtherStatusId"
                id="changeOtherStatusId"
                disabled={
                  !state.changeStatusId ||
                  state.changeStatusId == 1 ||
                  state.changeStatusLoading ||
                  state.selectedOrder.orderStatusId == 21
                }
                onClick={(e) => {
                  e.preventDefault();
                  const value = state.changeOtherStatusId == 2 ? "" : 2;
                  onHandleChange({
                    target: {
                      name: "changeOtherStatusId",
                      value: value,
                    },
                  });
                }}
                value={state.changeOtherStatusId}
                variant={
                  state.changeOtherStatusId == 2 ? "contained" : "outlined"
                }
                color="primary"
                className={classes.button}
                startIcon={state.changeOtherStatusId == 2 ? <DoneIcon /> : null}
              >
                Returned
              </Button>
            </div>
            <div
              style={{
                margin: 10,
              }}
            >
              <TextField
                fullWidth
                id="changeStatusRemarks"
                name="changeStatusRemarks"
                label="Remarks"
                value={state.changeStatusRemarks}
                type="text"
                variant={"outlined"}
                onChange={onHandleChange}
                size="small"
                margin="dense"
                multiline
                rows={3}
                disabled={
                  state.changeStatusLoading ||
                  state.selectedOrder.orderStatusId == 21
                }
                InputProps={{
                  style: { fontSize: "12px" }, // Adjust font size for input text
                }}
                InputLabelProps={{
                  style: { fontSize: "12px" }, // Adjust font size for label text
                }}
              />
            </div>
            <Divider />
            <div className={classes.actions}>
              <Button
                variant="contained"
                color="default"
                size="small"
                className={classes.button}
                disabled={state.changeStatusLoading}
                onClick={(e) => {
                  e.preventDefault();
                  handleClose();
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.button}
                disabled={
                  state.changeStatusLoading ||
                  state.selectedOrder.orderStatusId == 21
                }
                onClick={(e) => onSaveClick(e)}
              >
                {state.changeStatusLoading ? (
                  <CircularProgress size={22} color="primary" />
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </Fragment>
        }
      />
    </Fragment>
  );
};

C13ChangeDeliveryStatusDialog.propTypes = {
  handleClose: PropTypes.func,
  onHandleChange: PropTypes.func,
  onSaveClick: PropTypes.func,
  open: PropTypes.bool,
  state: PropTypes.object,
};

C13ChangeDeliveryStatusDialog.defaultProps = {
  handleClose: (fn) => fn,
  onHandleChange: (fn) => fn,
  onSaveClick: (fn) => fn,
  open: false,
  state: {},
};

export default C13ChangeDeliveryStatusDialog;
